import { useWorkspaceManagerContext } from './workspaceManagerContext'

export const useCurrentWorkspace = () => {
  const { getWorkspace, currentWorkspaceKey } = useWorkspaceManagerContext()
  return currentWorkspaceKey ? getWorkspace(currentWorkspaceKey) : undefined
}
